import { useContext } from "react";
import { EditorContext } from "../EditorCommon/EditorContext";

export function UseDamperSetter(props: Exclude<React.HTMLProps<HTMLInputElement>, {type: any, onChange: any, checked: any}>) {
    const ec = useContext(EditorContext);

    async function setUseDamper(evt: React.ChangeEvent<HTMLInputElement>) {
        const use = evt.target.checked;
        const result = await ec.cabinetService.setUseDamping(use);
        if (!result.success)
            return;
    }

    return (
        <input
            {...props}
            type="checkbox"
            onChange={setUseDamper}
            checked={ec.cabinet.doorDampening ?? false}
        />
        
    );
}
